import { useContext } from "react";
import { Element } from "react-scroll";
import { Container } from "../..";
import getStartedParagraph from "../../../assets/img/jiffy4.png";
import { Form } from "../../Form";
import { ThemeContext } from "../../context";
import {
  JiffyContainer,
  JiffyContentController,
  JiffyImage,
  JiffyStartedHeading,
  JiffyStartedParagraph,
} from "./GetStarted.elements";

export const GetStarted = () => {
  const { rooTheme } = useContext(ThemeContext);
  const entries = [
    {
      id: 1,
      type: "email",
      placeholder: "Enter Email Address",
      typePlaceholder: "Select type",
    },
  ];
  return (
    <>
      <Element id="Get Started" name="Get Started">
        <Container>
          <JiffyContainer rooTheme={rooTheme} className="">
            <JiffyContentController>
              <div className="flex flex-col justify-center h-[100%]">
                <JiffyStartedHeading rooTheme={rooTheme}>
                  Get Started with Jiffy
                </JiffyStartedHeading>
                <JiffyStartedParagraph rooTheme={rooTheme}>
                  Become one of the first user of this solution as we will be
                  launching soon
                </JiffyStartedParagraph>
                <Form
                  entries={entries}
                  isflex={true}
                  formWidthButton="15%"
                  // formbg="white"
                  opacity={1}
                  formcolor="rgba(30, 30, 30, 0.7)"
                  // isborder={true}
                  paddingvals="16.5px 30px"
                />
              </div>
              <div>
                <JiffyImage src={getStartedParagraph} alt="jiffy" />
              </div>
            </JiffyContentController>
          </JiffyContainer>
        </Container>
      </Element>
    </>
  );
};
